import { createEvent, createStore } from 'effector';

export const atualizaLoadingCursos = createEvent<boolean>();

export const $isLoadingCursos = createStore<boolean>(false).on(atualizaLoadingCursos, (_, value) => value);
